/*
 * @Author: your name
 * @Date: 2020-11-25 10:40:24
 * @LastEditTime: 2020-11-25 15:55:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ufun-new-bc/src/util/log.js
 */

import chalk from 'chalk'
import {REDUX_LOG_OPEN} from '@/constant'
chalk.level = 3;

// 添加redux输出颜色
chalk.redux=(...args)=>REDUX_LOG_OPEN?chalk.magenta('redux | ',args):''

export default chalk